import { useState, useEffect } from "react";
import { Download } from "lucide-react";

export const InstallPWA = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => setVisible(false);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <button
      data-testid="install-pwa-btn"
      onClick={install}
      className="hidden items-center gap-2 rounded-full border border-[#00E676]/40 px-4 py-2 text-sm font-semibold text-[#00E676] transition-colors hover:bg-[#00E676]/10 sm:flex"
    >
      <Download className="h-4 w-4" /> Install app
    </button>
  );
};
